const shaoxingRouter = [
  {
    path: '/index',
    name: 'shaoxingHomePage',
    meta: {
      noCheckLogin: true, // true 不需要登录验证,  false 需要登录验证
    },
    component: () => import('@/pages/shaoxing/homePage'),
  },
];

export default shaoxingRouter;


// WEBPACK FOOTER //
// ./src/router/shaoxing.js